import WorkGroupManagementApi from "../../workgroup-management/api/WorkGroupManagementApi";

export const _requestGetListWorkgroup = async (params: any) => {
  try {
    return await WorkGroupManagementApi.getWorkGroupsV2(params);
  } catch (err) {
    return false;
  }
};
